// extracted by mini-css-extract-plugin
module.exports = {"swatch":"Swatch_swatch__GDm0T Button_root__G_l9X","color":"Swatch_color__EE_Bp","dark":"Swatch_dark__JfVeH","active":"Swatch_active__UtqPO","textLabel":"Swatch_textLabel__ra4R0"};